module.exports = __webpack_public_path__ + "img/files.afd890d1.svg";